import React from 'react'
import {Table} from 'antd'

import {formatDate} from 'lib/dateHelpers'
import t from 'lib/translations'

interface BookedServiceProvider {
  id: string
  name: string
  email: string
}

interface Props {
  currentBookingId: string
  bookings: {
    edges: {node: any}[]
  }
  bookedServiceProviders: BookedServiceProvider[]
}

interface OtherBooking {
  key: string
  products: string
  state: string
  resourceName?: string
  resourceEmail?: any
  time?: string
}


function OtherBookingsTable({ currentBookingId, bookings, bookedServiceProviders }: Props) {
  const otherBookings: OtherBooking[] = []
  bookings.edges.forEach(({node}: any) => {
    const {id, state, resourceName} = node
    const resource = bookedServiceProviders.find((sp) => sp.name === resourceName)
    const products = node.products.edges.map(({node}: any) => node.name).join(', ')
    otherBookings.push({
      key: id,
      products,
      state: node.id === currentBookingId ? t(`bookingState.${state} (gjeldende)`) : t(`bookingState.${state}`),
      resourceName: resource ? `${resource.name}`  : '',
      resourceEmail: resource && resource.email ? <a href={`mailto:${resource.email}`}>{resource.email}</a> : '',
      time: node.startsAt ? formatDate(node.startsAt, 'DD.MM.YYYY HH:mm'): undefined,
    })
  })

  return (
    <Table
      size="small"
      pagination={false}
      columns={[
        {key: 'products', dataIndex: 'products', title: 'Produkter'},
        {key: 'state', dataIndex: 'state', title: 'Status'},
        {key: 'resourceName', dataIndex: 'resourceName', title: 'Ressursperson'},
        {key: 'resourceEmail', dataIndex: 'resourceEmail', title: 'E-post'},
        {key: 'time', dataIndex: 'time', title: 'Tidspunkt'},
      ]}
      dataSource={otherBookings}
    />
  )
}

export default OtherBookingsTable
